import { COLORS } from '../../constants/theme';

interface LandDistributionBarProps {
  totalLand: number;
  builtAcres: number;      // owned only (SF-132: corrected — was documented as owned + in-progress, but Buildings.tsx has always passed owned-only)
  pendingAcres: number;    // current buildQty totals
  barrenAcres: number;     // remaining unallocated
}

export function LandDistributionBar({
  totalLand,
  builtAcres,
  pendingAcres,
  barrenAcres,
}: LandDistributionBarProps) {
  if (totalLand <= 0) {
    return null;
  }

  const builtPct = (builtAcres / totalLand) * 100;
  const pendingPct = (pendingAcres / totalLand) * 100;
  const barrenPct = (barrenAcres / totalLand) * 100;

  const ariaLabel = `Land distribution: ${builtPct.toFixed(1)}% built, ${pendingPct.toFixed(1)}% pending, ${barrenPct.toFixed(1)}% barren`;

  return (
    <div>
      {/* Stacked bar */}
      <div
        role="img"
        aria-label={ariaLabel}
        className="rounded overflow-hidden flex"
        style={{ height: '12px', backgroundColor: COLORS.border }}
      >
        {builtPct > 0 && (
          <div
            style={{
              width: `${builtPct}%`,
              backgroundColor: COLORS.text.tertiary,
              opacity: 0.6,
            }}
          />
        )}
        {pendingPct > 0 && (
          <div
            style={{
              width: `${pendingPct}%`,
              backgroundColor: '#B89878',
              opacity: 0.5,
            }}
          />
        )}
        {barrenPct > 0 && (
          <div
            style={{
              width: `${barrenPct}%`,
              backgroundColor: COLORS.border,
            }}
          />
        )}
      </div>

      {/* Legend */}
      <div className="flex justify-between mt-1.5 text-xs" style={{ color: COLORS.text.tertiary }}>
        <span>
          <span style={{ color: COLORS.text.secondary, opacity: 0.6 }}>■</span>{' '}
          Built {builtPct.toFixed(1)}%
        </span>
        {pendingPct > 0 && (
          <span>
            <span style={{ color: '#B89878', opacity: 0.5 }}>■</span>{' '}
            Pending {pendingPct.toFixed(1)}%
          </span>
        )}
        <span>
          <span style={{ color: COLORS.border }}>■</span>{' '}
          Barren {barrenPct.toFixed(1)}%
        </span>
      </div>
    </div>
  );
}
